import { render, staticRenderFns } from "./lead-iframe-popup.vue?vue&type=template&id=f82008e2"
import script from "./lead-iframe-popup.vue?vue&type=script&lang=js"
export * from "./lead-iframe-popup.vue?vue&type=script&lang=js"
import style0 from "./lead-iframe-popup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports